// extracted by mini-css-extract-plugin
module.exports = {"container":"Ok-z","disabled":"Pk-z","bgBlack":"Qk-z","content":"Rk-z","countdown":"Sk-z","topCaption":"Tk-z","topHeading":"Uk-z","heading":"Vk-z","copy":"Wk-z"};